import { IconButton, type IconButtonProps } from '@mui/material';
import { ArrowRight2, ArrowUp2 } from 'iconsax-react';
import type { FC, ReactElement } from 'react';

type Props = Omit<IconButtonProps, 'children'> & {
  expand: boolean;
};

export const ExpandMore: FC<Props> = ({ expand, sx, ...other }): ReactElement => (
  <IconButton sx={[{ color: 'SlabIndigo.700' }, ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
    {expand ? <ArrowUp2 /> : <ArrowRight2 />}
  </IconButton>
);
